// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ee-a";
export var fulfillmentFormRail = "_ee-9";
export var headerTitleRow = "_ee-c";
export var orderDetailsWrapper = "_ee-7";
export var orderLinkTrigger = "_ee-2";
export var paymentInformationGrid = "_ee-h";
export var paymentSummaryColumn = "_ee-i";
export var shipmentContainer = "_ee-b";
export var shipmentDetailsMainPane = "_ee-8";
export var shipmentNavigationCard = "_ee-5";
export var shipmentNavigationRail = "_ee-3";
export var shipmentNavigationRailHeader = "_ee-4";
export var shipmentSummaryFact = "_ee-e";
export var shipmentSummaryGrid = "_ee-d";
export var shipmentSummaryMetadataRow = "_ee-f";
export var shipmentSummaryTags = "_ee-g";
export var shipmentWorkspace = "_ee-0";
export var shipmentWorkspaceContent = "_ee-6";
export var shipmentWorkspaceHeader = "_ee-1";